import { FontWeights, IButtonStyles, IconButton, IIconProps, ITag, mergeStyleSets, MessageBarType, Modal, useTheme } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IUserListItem } from '../../../../../Models/Admin/IUserListItem';
import { IAddEventTeacher } from '../../../../../Models/Event/IAddEventTeacher';
import { AddAttendeeRegistrationView } from '../../Events/AddAttendeeRegistration/AddAttendeeRegistrationView';
import { AddTeacherToEventView } from './AddTeacherToEventView';
import * as Services from '../../../../../Services/Services';
import { IAdminApi } from '../../../../../Services/API/Admin/IAdminApi';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';

interface IAddTeacherToEventProps {
    eventId: number;
    refresh: (eventId: number) => void;
    onDismiss: () => void;
    isOpened: boolean;
}

export interface IUserTag extends ITag {
    data: IUserListItem
}

export const AddTeacherToEvent: React.FunctionComponent<IAddTeacherToEventProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>();
    const [teacher, setTeacher] = React.useState<IAddEventTeacher>();
    const [selectedItems, setSelectedItems] = React.useState<ITag[]>([]);

    React.useEffect(() => {

        if (selectedItems && selectedItems.length === 1) {
            setTeacher({
                eventId: props.eventId,
                mainTeacher: false,
                payment: 0,
                userId: selectedItems[0].key as string
            });
        }
        else
        {
            setTeacher(undefined);
        }

    }, [selectedItems])

    const find = async (text: string): Promise<IUserTag[]> => {
        if (text) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
            const users = await adminApi.getUserInRole("Teacher", text);
            if (users.isSuccess && users.data) {
                setIsLoading.setFalse();
                const d = users.data ? users.data.map(item => {
                    return {
                        key: item.id, name: (item.company ? item.company : `${item.firstName} ${item.lastName}`), data: item
                    }
                }) : []
                return d;
            }
            else {
                setStatusMessage({ message: users.message, type: MessageBarType.error });
                setIsLoading.setFalse();
            }
        }
        return [];
    }

    const save = async (eventId: number, teacher?: IAddEventTeacher) => {
        if (teacher) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
            const eventType = await eventTypeApi.addEventTeacher(eventId, teacher)

            if (eventType.isSuccess && eventType.data) {
                await props.refresh(eventId);                
                setSelectedItems([]);
                props.onDismiss();
            }
            else {
                setStatusMessage({ message: eventType.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    };

    const propertyChanged = (key: string, value: any) => {
        if (teacher) {
            setTeacher({ ...teacher, [key]: value });
        }
    }
     

    return (
        <AddTeacherToEventView
            statusMessage={statusMessage}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            propertyChanged={propertyChanged}
            eventId={props.eventId}
            teacher={teacher}
            save={save} onDismiss={props.onDismiss} find={find} isOpened={props.isOpened} />)
}
